import { all, fork, put, call, takeEvery, select } from 'redux-saga/effects';
import { actions } from '../reducers/layer';
import { fetchAllLayers, fetchDefaultLayers } from '@api/layer'; // call은 동기, fork는 비동기 요청
function* getAllLayers(action) {
    const { id } = action; // global.ts 에서 vrType 을 받아옴
    // const { vrtype } = useSelector((state) => state.global);
    const vrtype = yield select(state => state.global.vrtype);
    try {
        const data = yield call(fetchAllLayers, id, vrtype);
        yield put({ type: actions.GET_ALL_LAYERS_SUCCESS, data });
    }
    catch (err) {
        yield put({ type: actions.GET_ALL_LAYERS_FAILURE, error: err.message });
    }
}
function* getDefaultLayerAction(action) {
    const { id } = action; // global.ts 에서 vrType 을 받아옴
    const vrtype = yield select(state => state.global.vrtype);
    try {
        const data = yield call(fetchDefaultLayers, id, vrtype);
        yield put({ type: actions.GET_DEFAULT_LAYERS_SUCCESS, data });
    }
    catch (err) {
        yield put({ type: actions.GET_DEFAULT_LAYERS_FAILURE, error: err.message });
    }
}
function* watchGetAllLayers() { yield takeEvery(actions.GET_ALL_LAYERS_REQUEST, getAllLayers); }
function* watchGetDefaultLayer() { yield takeEvery(actions.GET_DEFAULT_LAYERS_REQUEST, getDefaultLayerAction); }
export default function* layerSaga() { yield all([fork(watchGetAllLayers), fork(watchGetDefaultLayer)]); }
